<template>
  <div class="table-page">
    <div class="cnt-header">
      <div class="top-btn">
        <el-button-group>
          <el-button type="primary" @click="addProjectBtn">添加项目</el-button>
        </el-button-group>
      </div>
      <div class="search-input">
        <div class="filter-top" v-show="userInfo.is_admin">
          <label class="filter-label">筛选：</label>
          <el-select
            v-model="filter"
            @clear="filterClear"
            @change="filterChange"
            clearable
            placeholder="请选择负责人"
          >
            <el-option
              v-for="item in filterOpts"
              :key="item.user_id"
              :label="item.username"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </div>

        <el-input
          style="width: 355px"
          :clearable="true"
          placeholder="输入(会议名称/编号/单位/地点)检索项目"
          class="input-with-select"
          v-model="query"
          @keyup.enter.native="startQuery"
          @clear="clearInputVal"
        >
          <el-button slot="append" icon="el-icon-search" @click="startQuery"></el-button>
        </el-input>
      </div>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="meet_name" label="会议名称"> </el-table-column>
      <el-table-column prop="meet_num" label="会议编号"> </el-table-column>
      <el-table-column prop="meet_time" label="会议时间"> </el-table-column>
      <el-table-column prop="company" label="承接单位"> </el-table-column>
      <el-table-column prop="meet_addr" label="会议地点"> </el-table-column>
      <el-table-column prop="user.username" label="负责人"> </el-table-column>
      <el-table-column label="审核状态" v-if="!userInfo.is_admin">
        <template slot-scope="scope">
          <div v-if="(scope.row.verify_info.status === 1) && (scope.row.verify_info.typ === 'budget')" style="color: #E6A23C">
            <span>预算审核通过</span>&nbsp;<i class="el-icon-success"></i>
          </div>
          <el-tooltip v-else-if="(scope.row.verify_info.status === -1) && (scope.row.verify_info.typ === 'budget')" placement="bottom">
            <div style="color: #f56c6c">
              <span>预算审核拒绝</span>&nbsp;<i class="el-icon-error"></i>
            </div>
            <div slot="content">
              {{ scope.row.verify_info.remark }}
            </div>
          </el-tooltip>
          <div v-else-if="(scope.row.verify_info.status === 0) && (scope.row.verify_info.typ === 'budget')" style="color: #e6a23c">
            <span>预算审核中</span>&nbsp;<i class="el-icon-remove"></i>
          </div>
          <div v-else-if="(scope.row.verify_info.status === 1) && (scope.row.verify_info.typ === 'final')" style="color: #67c23a">
            <span>决算审核通过</span>&nbsp;<i class="el-icon-success"></i>
          </div>
          <el-tooltip v-else-if="(scope.row.verify_info.status === -1) && (scope.row.verify_info.typ === 'final')" placement="bottom">
            <div style="color: #f56c6c">
              <span>决算审核拒绝</span>&nbsp;<i class="el-icon-error"></i>
            </div>
            <div slot="content">
              {{ scope.row.verify_info.remark }}
            </div>
          </el-tooltip>
          <div v-else-if="(scope.row.verify_info.status === 0) && (scope.row.verify_info.typ === 'final')" style="color: #e6a23c">
            <span>决算审核中</span>&nbsp;<i class="el-icon-remove"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addStatement(scope.row.project_id)"
            >结算单</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editProjectInfo(scope.row.project_id)"
            :disabled="scope.row.verify_info.status === 1"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="delProjectInfo(scope.row.project_id)"
            :disabled="(scope.row.verify_info.status === 1) && (scope.row.verify_info.typ === 'final')"
            >删除</el-button
          >
          <el-button type="text" size="small" style="color: #E6A23C"
                     v-if="(scope.row.verify_info.status === 1) && (scope.row.verify_info.typ === 'budget')"
                     @click="handleBorrowClick(scope.row.project_id)"
          >活动借款单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 25px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../utils/utils.js";
export default {
  data() {
    return {
      filterOpts: [],
      filter: null,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      query: null,
    };
  },
  methods: {
    handleBorrowClick(project_id){
      let that = this;
      that.fullscreenLoading = true;
      let reqUrl = that.host + "/api/activity/approve/exporter?project_id=" + project_id;
      that.$axios
          .get(reqUrl, {
            responseType: "blob",
            headers: {"Cache-Control": "no-cache"},
          })
          .then((res) => {
            let blob = new Blob([res.data]);
            let link = document.createElement("a");
            link.download = "活动借款单.pdf";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            that.fullscreenLoading = false;
          })
          .catch((err) => {
            let resData = err.data;
            if(err.data.type == "application/json"){
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                let jsonData = JSON.parse(fileReader.result)
                // 后台信息
                that.$message.error(jsonData.errmsg);
                that.fullscreenLoading = false;
              }
              fileReader.readAsText(resData);
            }
          });
    },
    filterChange() {
      let that = this;
      that.currentPage = 1;
      that.loadProject();
    },
    filterClear() {
      let that = this;
      that.currentPage = 1;
      that.loadProject();
    },
    startQuery() {
      let that = this;
      that.currentPage = 1;
      if (that.query) {
        if (!that.query.trim()) {
          that.query = null;
        }
      }
      that.loadProject();
    },
    clearInputVal() {
      let that = this;
      that.currentPage = 1;
      that.loadProject();
    },
    addStatement(project_id) {
      let that = this;
      that.$router.push({
        path: "/statement/list",
        query: {
          project_id: project_id,
        },
      });
    },
    handleCurrentChange(val) {
      let that = this;
      that.currentPage = val;
      that.loadProject();
    },
    handleSizeChange(val) {
      let that = this;
      that.pageSize = val;
      that.loadProject();
    },
    addProjectBtn() {
      let that = this;
      that.$router.push({
        path: "/statement/projects/detail",
      });
    },
    editProjectInfo(project_id) {
      let that = this;
      that.$router.push({
        path: "/statement/projects/detail",
        query: {
          project_id: project_id,
        },
      });
    },
    delProjectInfo(project_id) {
      let that = this;
      this.$confirm("此操作将永久删除该项目信息, 是否继续?", "删除项目", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          that.$axios
            .delete(that.host + "/api/projects", {
              data: { project_id: project_id },
            })
            .then((res) => {
              that.$message.success("删除项目信息成功");
              that.loadProject();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    loadProject() {
      let that = this;
      let reqUrl =
        that.host +
        "/api/projects?page=" +
        that.currentPage +
        "&page_size=" +
        that.pageSize;
      if (that.query) {
        reqUrl += "&query=" + that.query;
      }
      if (that.filter) {
        reqUrl += "&user_id=" + that.filter;
      }
      that.$axios
        .get(reqUrl)
        .then((res) => {
          let results = res.data.results;
          that.total = results.total_count;
          that.tableData = results.projects;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    loadFilterOpts() {
      // 加载筛选选项
      let that = this;
      that.$axios
        .get(that.host + "/api/users/opts")
        .then((res) => {
          that.filterOpts = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
  },
  mounted() {
    let that = this;
    that.loadProject();
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (that.userInfo.is_admin) {
        that.loadFilterOpts();
      }
    });
  },
};
</script>

<style>
.filter-label {
  font-size: 14px;
  color: #e6a23c;
}
.cnt-header {
  position: relative;
  margin-bottom: 25px;
  line-height: 34px;
}
.filter-top {
  margin-right: 25px;
  display: inline-block;
}
.cnt-header .top-btn {
  display: inline-block;
}
.cnt-header .search-input {
  float: right;
}
.table-page {
  padding: 0 30px 0 30px;
}
</style>
